var _excluded = ["url", "className", "dataSpacer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
/* eslint-disable react/jsx-props-no-spreading */
import ReactPlayer from "react-player";
import { FixedAspectRatioContainer } from "#library/components/FixedAspectRatioContainer/FixedAspectRatioContainer";
export var VideoPlayer = function VideoPlayer(_ref) {
  var url = _ref.url,
    className = _ref.className,
    dataSpacer = _ref.dataSpacer,
    playerProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(FixedAspectRatioContainer, {
    className: className,
    dataSpacer: dataSpacer
  }, /*#__PURE__*/React.createElement(ReactPlayer, _extends({
    controls: true,
    width: "100%",
    height: "100%",
    url: url
  }, playerProps)));
};